// extracted by css-extract-rspack-plugin
var _1 = "Switch-m_switch-CxJBc7Yq";
export { _1 as "switch" }
